import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';
import { getSegmentLeaderboard } from '../api/platform';

export interface GetAssignedLearningListObjectState {
  segment: [];
  isLoading: boolean;
  error?: string;
}

const initialState: GetAssignedLearningListObjectState = {
  segment: [],
  isLoading: false,
  error: undefined
};

export const getSegmentListEvents = createAsyncThunk(
  'getSegmentListEventLeaderboard',
  async ()  => {
    const response : any = await getSegmentLeaderboard();
    if(response && Object.keys(response?.data).length > 0){
      return Array.from(new Set(Object.values(response.data)))
    } else {
      return initialState.segment
    }
  }
);

export const getSegmentListSlice = createSlice({
  name: 'getSegmentListEvents',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSegmentListEvents.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      getSegmentListEvents.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.segment = action.payload.map((item: any, index: number) => ({
          id: index,
          content: item
        }));
        state.error = undefined;
      }
    );

    builder.addCase(getSegmentListEvents.rejected, (state, action) => {
      state.isLoading = false;
      state.segment = initialState.segment;
      state.error = action.payload as string;
    });
  }
});

export const getSegmentListEventsDataSelector = (state: RootState) =>
  state.getSegmentListEvents;
export default getSegmentListSlice.reducer;
